module.exports = __webpack_public_path__ + "img/logo.8c22f8c6.png";